import React, { useState } from 'react';
import { processSource } from '../../services/sourceService';
import { Button, Toast, Spinner } from '../ui';
import { Play } from '../ui/icons';

interface IProcessSourceButtonProps {
  sourceId: string;
  onProcessComplete?: () => void;
  disabled?: boolean;
}

const ProcessSourceButton: React.FC<IProcessSourceButtonProps> = ({
  sourceId,
  onProcessComplete,
  disabled = false
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleProcess = async () => {
    setIsProcessing(true);
    setError(null);
    setSuccess(null);

    try {
      await processSource(sourceId);
      setSuccess('Processing has been triggered successfully');
      if (onProcessComplete) {
        onProcessComplete();
      }
    } catch (err) {
      console.error('Error processing source:', err);
      setError('Failed to trigger source processing');
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCloseError = () => {
    setError(null);
  };

  const handleCloseSuccess = () => {
    setSuccess(null);
  };

  return (
    <>
      <Button
        variant="primary"
        onClick={handleProcess}
        disabled={isProcessing || disabled}
      >
        {isProcessing ? (
          <>
            <Spinner size="sm" className="mr-2" />
            Processing...
          </>
        ) : (
          <>
            <Play className="h-4 w-4 mr-2" />
            Process Now
          </>
        )}
      </Button>

      <Toast
        open={!!error}
        message={error || ''}
        variant="error"
        onClose={handleCloseError}
        autoHideDuration={6000}
      />

      <Toast
        open={!!success}
        message={success || ''}
        variant="success"
        onClose={handleCloseSuccess}
        autoHideDuration={6000}
      />
    </>
  );
};

export default ProcessSourceButton;
